import * as mutationType from "../mutation_types";

const state = {
  list: [],
  drawer: false,
  rankings: []
};

const getters = {
  core_card: state => type => {
    return state.list.find(x => x.type == type);
  },
  drawer: state => state.drawer,
  rankings: state => state.rankings
};

const actions = {
  getCoreCard({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/corecard", filter)
        .then(res => {
          if (res.data) {
            commit(mutationType.SET_CORE_CARD, res.data);
          } else {
            commit(mutationType.REMOVE_CORE_CARD, filter.type);
          }
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  resetCoreCards({ commit }) {
    return new Promise(resolve => {
      commit(mutationType.RESET_CORECARD_LIST, []);
      resolve();
    });
  },
  setDrawer({ commit }, val) {
    return new Promise(resolve => {
      commit(mutationType.SET_CORECARD_DRAWER, val);
      resolve();
    });
  },
  getCoreCardRankings({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/corecard/rankings", filter)
        .then(res => {
          commit(mutationType.SET_CORE_CARD_RANKINGS, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_CORE_CARD](state, card) {
    var index = state.list.findIndex(x => x.type == card.type);
    if (index >= 0) {
      state.list.splice(index, 1);
    }
    state.list.push(card);
  },
  [mutationType.REMOVE_CORE_CARD](state, type) {
    var index = state.list.findIndex(x => x.type == type);
    if (index >= 0) {
      state.list.splice(index, 1);
    }
  },
  [mutationType.SET_CORECARD_DRAWER](state, val) {
    state.drawer = val;
  },
  [mutationType.RESET_CORECARD_LIST](state, list) {
    state.list = list;
  },
  [mutationType.SET_CORE_CARD_RANKINGS](state, list) {
    state.rankings = list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
